'use client';

import { useEffect } from 'react';
import { trackEvent } from '@/lib/analytics';

interface INotFoundTelemetryProps {
  path: string;
  locale: string;
}

export function NotFoundTelemetry({ path, locale }: INotFoundTelemetryProps): null {
  useEffect(() => {
    trackEvent('page_not_found', {
      path,
      locale,
      referrer: document.referrer || '',
    });
  }, [path, locale]);
  return null;
}
